var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BalanceScale = function BalanceScale(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 20a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1ZM11.836 4.014a1 1 0 0 1 .328 0l6 1a1 1 0 1 1-.328 1.972L12 6.014l-5.836.972a1 1 0 1 1-.328-1.972l6-1Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2a1 1 0 0 1 1 1v17a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1ZM6 5a1 1 0 0 1 .894.553l3 6A1 1 0 0 1 10 12a4 4 0 1 1-8 0 1 1 0 0 1 .106-.447l3-6A1 1 0 0 1 6 5Zm-1.989 7.213a2 2 0 0 0 3.978 0L6 8.236l-1.989 3.977ZM18 5a1 1 0 0 1 .894.553l3 6c.07.139.106.292.106.447a4 4 0 1 1-8 0c0-.155.036-.308.106-.447l3-6A1 1 0 0 1 18 5Zm-1.989 7.213a2 2 0 0 0 3.978 0L18 8.236l-1.989 3.977Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default BalanceScale;